import { dialogContentEmits as P, dialogContentProps as S } from "./index643.js";
import { defineComponent as B, inject as C, computed as n, openBlock as r, createElementBlock as i, normalizeStyle as K, unref as o, normalizeClass as s, createElementVNode as c, renderSlot as d, toDisplayString as T, createVNode as V, withCtx as j, createBlock as z, resolveDynamicComponent as L, createCommentVNode as v } from "vue";
import { ElIcon as O } from "./index538.js";
import { dialogInjectionKey as A } from "./index638.js";
import { FOCUS_TRAP_INJECTION_KEY as F } from "./index761.js";
import { composeRefs as J } from "./index786.js";
import { useDraggable as U } from "./index701.js";
import { CloseComponents as Y } from "./index606.js";
import { useLocale as q } from "./index597.js";
const x = ["aria-level"], G = ["aria-label"], H = ["id"];
var le = /* @__PURE__ */ B({
  name: "ElDialogContent",
  __name: "dialog-content",
  props: S,
  emits: P,
  setup(t, { expose: b }) {
    const { t: h } = q(), { Close: p } = Y, l = t, { dialogRef: m, headerRef: f, bodyId: y, ns: e, style: k } = C(A), { focusTrapRef: E } = C(F), R = J(E, m), g = n(() => !!l.draggable), w = n(() => !!l.overflow), { resetPosition: D, updatePosition: I, isDragging: $ } = U(
      m,
      f,
      g,
      w
    ), N = n(() => [
      e.b(),
      e.is("fullscreen", l.fullscreen),
      e.is("draggable", g.value),
      e.is("dragging", $.value),
      e.is("align-center", !!l.alignCenter),
      { [e.m("center")]: l.center }
    ]);
    return b({
      resetPosition: D,
      updatePosition: I
    }), (a, u) => (r(), i(
      "div",
      {
        ref: o(R),
        class: s(N.value),
        style: K(o(k)),
        tabindex: "-1"
      },
      [
        c(
          "header",
          {
            ref_key: "headerRef",
            ref: f,
            class: s([o(e).e("header"), t.headerClass, { "show-close": t.showClose }])
          },
          [
            d(a.$slots, "header", {}, () => [
              c("span", {
                role: "heading",
                "aria-level": t.ariaLevel,
                class: s(o(e).e("title"))
              }, T(t.title), 11, x)
            ]),
            t.showClose ? (r(), i("button", {
              key: 0,
              "aria-label": o(h)("el.dialog.close"),
              class: s(o(e).e("headerbtn")),
              type: "button",
              onClick: u[0] || (u[0] = (M) => a.$emit("close"))
            }, [
              V(o(O), {
                class: s(o(e).e("close"))
              }, {
                default: j(() => [
                  (r(), z(L(t.closeIcon || o(p))))
                ]),
                _: 1
                /* STABLE */
              }, 8, ["class"])
            ], 10, G)) : v("v-if", !0)
          ],
          2
          /* CLASS */
        ),
        c("div", {
          id: o(y),
          class: s([o(e).e("body"), t.bodyClass])
        }, [
          d(a.$slots, "default")
        ], 10, H),
        a.$slots.footer ? (r(), i(
          "footer",
          {
            key: 0,
            class: s([o(e).e("footer"), t.footerClass])
          },
          [
            d(a.$slots, "footer")
          ],
          2
          /* CLASS */
        )) : v("v-if", !0)
      ],
      6
      /* CLASS, STYLE */
    ));
  }
});
export {
  le as default
};
